"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isModifierSelected = void 0;
const isModifierSelected = (modifierId, selections) => {
    return (selections === null || selections === void 0 ? void 0 : selections[modifierId]) === true;
};
exports.isModifierSelected = isModifierSelected;
//# sourceMappingURL=selections.js.map